import { useState, useEffect } from "react";
import ClosedIcon from "../../utils/assets/client/closed-icon.png";
import OpenIcon from "../../utils/assets/client/open-icon.png";
import ChangeIcon from "../../utils/assets/client/changes.png";
import DeclinedIcon from "../../utils/assets/client/declined.jpg";
import FilterIcon from "../../utils/assets/client/filter.svg";

import QuickViewCard from "../../components/client/QuickViewCard";
import "../../styles/client.css";
import {
  fetchEstimatesForUsers,
  updateEstimateNotes,
} from "../../actions/client/estimates";
import { Link } from "react-router-dom";
import NoteSVG from "../../utils/assets/client/wirte.svg";
import Modal from "../../components/client/modal";
import searchSVG from "../../utils/assets/client/search.svg";
import DoughnutChart from "../../components/admin/DoughnutChart";
import { toast } from "react-toastify";

const EstimatePage = () => {
  const [estimateData, setEstimateData] = useState([]);
  const [searchEstimateData, setSearchEstimateData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [inputData, setInputdata] = useState({
    id: "",
    status: "",
    date: "",
  });
  const [lockedChartData, setLockedChartData] = useState([]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const labelDataRef = ["Approved", "Declined", "Awaiting Response"];

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetchEstimatesForUsers(token).then((res) => {
      setEstimateData(res.data);
      setSearchEstimateData(res.data);
      const computedDataSetValueRef = labelDataRef.map(
        (label) => res.data.filter((data) => data.status === label).length
      );
      setStatusData(computedDataSetValueRef);
    });
  }, []);

  const handleEstimateSubmit = (id, is_approve) => {
    const Token = localStorage.getItem("token");
    const data = {
      estimate_id: id,
      is_approve: is_approve,
      note: null,
    };

    updateEstimateNotes(Token, data).then((res) => {
      if (res.success === true) {
        toast.success(res.data);
      } else {
        toast.error("Something went wrong");
      }
      const token = localStorage.getItem("token");

      fetchEstimatesForUsers(token).then((res) => {
        setEstimateData(res.data);
        setSearchEstimateData(res.data);
        const computedDataSetValueRef = labelDataRef.map(
          (label) => res.data.filter((data) => data.status === label).length
        );
        setStatusData(computedDataSetValueRef);
      });
    });
  };

  const handleSearch = () => {
    const filtered = estimateData.filter((item) => {
      // Filter by ID (exact match, includes if partial and numeric input)
      if (inputData.id && !item.id.toString().includes(inputData.id.trim())) {
        return false;
      }

      // Filter by status (case-insensitive and partial match)
      if (
        inputData.status &&
        !item.status
          ?.toLowerCase()
          .includes(inputData.status.trim().toLowerCase())
      ) {
        return false;
      }

      // Filter by date (exact date match in yyyy-mm-dd format)
      if (inputData.date) {
        const createdDate = new Date(item.created_at)
          .toISOString()
          .split("T")[0];
        if (createdDate !== inputData.date.trim()) {
          return false;
        }
      }

      return true;
    });

    setSearchEstimateData(filtered);
  };

  const handleClearFilter = () => {
    setInputdata({
      id: "",
      status: "",
      date: "",
    });
    setSearchEstimateData(estimateData);
  };


  return (
    <>
      <div
        className="container-fluid bg_color_gray "
        style={{ minHeight: "100% !important" }}
      >
        <div className="row">
          <div>
            <h4 className="my-3 px-2">Quick View</h4>
          </div>
        </div>
        {/* doughnut chart and search */}
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div className="card  text-start border_bg_color rounded shadow d-flex justify-content-center align-items-center">
              <DoughnutChart
                labelData={labelDataRef}
                dataSetValue={statusData}
                chartName="Estimates by Status"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-3 mt-lg-0">
            <div className="card p-3  border_bg_color rounded shadow ">
              <p className="f-24">Search Filters</p>
              <div className="row d-flex justify-content-start align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <label className="form-label">ID</label>
                  <input
                    value={inputData.id}
                    onChange={(e) =>
                      setInputdata({ ...inputData, id: e.target.value })
                    }
                    type="text"
                    className="form-control"
                    placeholder="Search ID"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <label className="form-label">Status</label>
                  <select
                    value={inputData.status}
                    onChange={(e) =>
                      setInputdata({ ...inputData, status: e.target.value })
                    }
                    className="form-select"
                    name=""
                    id=""
                  >
                    <option value="" selected>
                      Select Status
                    </option>

                    <option value="Approved">Approved</option>
                    <option value="Declined">Declined</option>
                  </select>
                  {/* <input type="text" className="form-control" placeholder="" /> */}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 my-3">
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    value={inputData.date}
                    onChange={(e) =>
                      setInputdata({ ...inputData, date: e.target.value })
                    }
                    className="form-control"
                  />
                </div>
              </div>
              <div className=" d-flex justify-content-start align-items-start mt-2">
                <button
                  onClick={() => handleClearFilter()}
                  className="btn bg-black text-white d-flex justify-content-center align-items-center"
                >
                  <img src={FilterIcon} width={20} alt="filter" />
                  <span className="mx-2">Clear Filter</span>
                </button>
                <button
                  onClick={() => handleSearch()}
                  className="btn bg-black text-white mx-3"
                >
                  Search{" "}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* table start */}
        <div className="row">
          <div className="my-3 ">
            <div className="rounded shadow  border_bg_col overflow-hidden">
              <div className="d-flex justify-content-start align-items-center bg-black text-white">
                <p className="txt-head  mb-0 p-2 px-3">Manage Estimate (s)</p>
                {/* <div>
            <div className="input-group">
              <input type="text" className="form-control card_radius" placeholder="Search..."  />
              <span className="input-group-text card_radius" id="basic-addon1"><img src={searchSVG} width={20} alt="search" /></span>
          </div>

           </div> */}
              </div>

              {!searchEstimateData.length > 0 ? (
                <table className="table  mb-0">
                  <thead>
                    <tr className="p-2">
                      <td>Id</td>
                      <td>Created Date</td>
                      <td>Device</td>
                      <td>Total</td>
                      <td>Status</td>
                      <td>Estimate Approval</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        colspan="6"
                        class="table-active"
                        className="text-center txt-p"
                      >
                        No Records
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <table className="table  table-hover mb-0">
                  <thead>
                    <tr className="p-2">
                      <td scope="col" className="px-4">
                        Id
                      </td>
                      <td scope="col">Created Date</td>
                      <td scope="col">Defect</td>
                      <td scope="col">Total</td>
                      <td scope="col">Status</td>
                      <td scope="col">Estimate Approval</td>
                    </tr>
                  </thead>
                  <tbody>
                    {searchEstimateData.length > 0 &&
                      searchEstimateData?.map((item) => {
                        return (
                          <tr className="p-3" key={item.id}>
                            <td className="px-4">
                              <Link
                                style={{ fontWeight: "500" }}
                                to={`/client/estimates/${item.id}`}
                              >
                                {item.id}
                              </Link>
                            </td>
                            <td>
                              {item.updated_at
                                ? new Date(item.updated_at).toLocaleDateString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    }
                                  )
                                : "-"}
                            </td>
                            <td>
                              <Link style={{textDecoration: "none", fontWeight: "500"}} to={`/client/estimates/${item.id}`}>
                                  {item?.lead?.lead_items[0]?.defects[0]?.title}
                              </Link>
                            </td>
                            <td>£ {item?.total_price}</td>
                            <td>
                              <span
                                className="badge p-2"
                                style={{
                                  backgroundColor: `${item.color_code}`,
                                  fontSize: "12px",
                                }}
                              >
                                {item.status}
                              </span>
                            </td>
                            <td>
                              {item.status === "Awaiting Response" ? (
                                <div className="d-flex">
                                  <button
                                    className="btn btn-sm  py-1 px-2 border bg-success text-white"
                                    onClick={() =>
                                      handleEstimateSubmit(item.id, true)
                                    }
                                  >
                                    Accept
                                  </button>
                                  <button
                                    className="btn btn-sm mx-2 py-1 px-2 border bg-danger text-white"
                                    onClick={() =>
                                      handleEstimateSubmit(item.id, false)
                                    }
                                  >
                                    Decline
                                  </button>
                                  <img
                                    className="mx-2"
                                    width={25}
                                    src={NoteSVG}
                                    alt="note"
                                    onClick={openModal}
                                  />
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              )}
            </div>
            <Modal
              isOpen={isModalOpen}
              onClose={closeModal}
              title="Write Your Note"
            >
              <div>
                <textarea
                  className="form-control"
                  placeholder="Note..."
                  cols="30"
                  rows="4"
                ></textarea>
              </div>
              <div className="d-flex justify-content-end align-items-end">
                <button
                  className=" bg-black text-white py-2 px-4 mt-4"
                  onClick={closeModal}
                >
                  Submit
                </button>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default EstimatePage;
